import { gql } from "apollo-boost";

export const CREATE_LISTING_AGENT_MATCH_ON_HDP_CONNECTION = gql`
  mutation createListingAgentMatchOnHDPConnection(
    $agent_name: String!
    $brokerage: String!
    $brokerage_address: String!
    $contact_id: ID!
    $email: String!
    $fingerprint_or_device_guid: String!
    $has_sold_in_building: Boolean
    $homes_sold_nearby: Int
    $homes_sold_recent: Int
    $homes_sold_similar: Int
    $is_pro: Boolean
    $license_type: String!
    $median_sales_price: String
    $name: String
    $notes: String
    $origin_label: String!
    $phone: String
    $photo_url: String
    $sale_id: ID!
    $user_id: ID
    $uuid: String
    $years_experience: Int
  ) {
    create_listing_agent_match_on_hdp_connection(
      input: {
        agent_name: $agent_name
        brokerage: $brokerage
        brokerage_address: $brokerage_address
        contact_id: $contact_id
        email: $email
        fingerprint_or_device_guid: $fingerprint_or_device_guid
        has_sold_in_building: $has_sold_in_building
        homes_sold_nearby: $homes_sold_nearby
        homes_sold_recent: $homes_sold_recent
        homes_sold_similar: $homes_sold_similar
        is_pro: $is_pro
        license_type: $license_type
        median_sales_price: $median_sales_price
        name: $name
        notes: $notes
        origin_label: $origin_label
        phone: $phone
        photo_url: $photo_url
        sale_id: $sale_id
        user_id: $user_id
        uuid: $uuid
        years_experience: $years_experience
      }
    ) {
      ... on ListingAgentMatch {
        contact_id
      }
      ... on ListingAgentMatchErrors {
        errors {
          message
          type
        }
      }
    }
  }
`;
